import { BOOKING_ENGINE_BASE_PATH } from 'utils/constants';
import queryString from 'query-string';

export const HOST_BOOKING = 'HOST_BOOKING';
export const SELF_SERVICE = 'SELF_SERVICE';

export function isHostBookingSource(bookingSource) {
  return bookingSource === HOST_BOOKING;
}

export function getBookingEnginePath(path = '') {
  return `${BOOKING_ENGINE_BASE_PATH}${path.replace(/^\/+/g, '')}`;
}

// This query param is only available when the app first loads,
// so this function should only be used to set the initial value
// in the redux store.
export function getBookingSource(location = null) {
  const searchString = location ? location.search : window.location.search;
  const params = queryString.parse(searchString);

  return params && params.source && params.source === HOST_BOOKING
    ? HOST_BOOKING
    : SELF_SERVICE;
}
